<template>
    <ul class="ruleset-tree">
      <li v-for="(node, index) in treeData" :key="index" :class="['tree-node', { highlighted: node.id === highlightedId }]">
        <div class="tree-node-content">
          <span v-if="node.children.length" @click="toggleNode(node)" >
            <span v-if="node.expanded">▼</span>
            <span v-else>►</span>
          </span>
          <span @click="toggleNode(node)" :class="{ rulesetBlock: node.type == 'Ruleset'}" class="node-name" @dblclick="shareProps(node.id, emailData[node.id])">
            <div class="nodeName">
            <span class="material-symbols-outlined">{{getIconMapping(node.type)}}</span>
            <span class="name">{{ node.name }}</span> 
          </div>
          </span>
        </div>
        <!-- Recursively show children -->
        <ul v-if="node.expanded" class="tree-children">
          <p style="text-align: left; color:darkgray; font-size: 12px; margin-top: 1px;">{{ $t('RulesetTree.Created') }}: {{ node.creationDate }}</p>
          <RulesetTree 
            v-for="(child, idx) in node.children" 
            :key="idx" 
            :treeData="[child]" 
            :highlightedId="highlightedId" 
            :level="level + 1"
          />
        </ul>
      </li>
    </ul>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'RulesetTree',
  props: {
    treeData: { type: Array  }, // Single tree node
    highlightedId: { type: String, default: '' },  // ID to highlight
    level: { type: Number, default: 0 } // Indentation Level
  },
  computed: {
    ...mapGetters(['getEmailData']),
    emailData() {
      return this.getEmailData;
    },
    iconMapping() {
      return {
        Heading: 'format_h1',
        Text: 'text_fields',
        Button: 'buttons_alt',
        Image: 'image',
        Spacer: 'rectangle',
        Divider: 'horizontal_rule',
        Container: 'add_to_photos',
        ColumnsContainer: 'splitscreen_vertical_add',
        Html: 'html',
        Table: 'table_rows',
        Ruleset: 'rule',
        Boilerplate: 'folder',
        DynContainer: 'dynamic_form'
      };
    }
  },
  data() {
    return {
      localTreeData: this.treeData, // Local copy of the treeData
    };
  },
  methods: {
    ...mapActions(['updateSharedData']),
    shareProps(childId, data) {
      this.updateSharedData({id: childId, data});
    },
    toggleNode(node) {
      node.expanded = !node.expanded; // Toggle the expanded state
    },
    getIconMapping(type){
      return this.iconMapping[type] || '';  // Gibt den Icon-Namen zurück
    }
    // Traverse emailData to create hierarchical tree data for Ruleset Blocks
   /*  listRulesetBlocks(emailData) {
      const rulesetBlocks = [];

      const traverseBlocks = (blockId, parentId = null, level = 0) => {
        const block = emailData[blockId];
        if (!block) return;

        if (block.type === 'Ruleset') {
          const node = {
            id: blockId,
            name: emailData[blockId].data.props?.ruleName || `Ruleset Block Level ${level}`, // Use blockId or some other meaningful name
            parentId: parentId,
            level: level,
            expanded: false,
            children: [],
          };

          if (block.data?.props?.childrenIds) {
            block.data.props.childrenIds.forEach(childId => {
              const childNode = traverseBlocks(childId, blockId, level + 1);
              if (childNode) {
                node.children.push(childNode);
              }
            });
          }
          return node;
        }
      };

      if (emailData.root?.data.childrenIds) {
        emailData.root.data.childrenIds.forEach(blockId => {
          const blockNode = traverseBlocks(blockId);
          if (blockNode) rulesetBlocks.push(blockNode);
        });
      }

      return rulesetBlocks;
    }, */
  },
  mounted() {
    console.log('data:', this.localTreeData)
  }
};
</script>



<style scoped>
.ruleset-tree-wrapper {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  max-width: 600px;
  margin: 0 auto;
  background-color: #f9f9f9;
}

.ruleset-tree {
  list-style-type: none;
  padding-left: 10px;
 
}

.tree-node {
  position: relative;
  padding-left: 20px;
  margin-left: 10px;
  border-left: 1px solid #ccc; /* Line between parent and children */
}

.nodeName{
  display: flex;
  align-items:center;
  margin-bottom: 5px;
}

.tree-node-content {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.node-name {
  margin-left: 5px;
}

.name:hover{
  text-decoration: underline;
}
.name{
  padding-left: 5px;
}


.tree-children {
  list-style-type: none;
  padding-left: 20px;
}

.tree-node:before {
  content: '';
  position: absolute;
  left: 0;
  top: 15px;
  width: 10px;
  height: 1px;
  background: #ccc; /* Line to child */
}

.tree-node.highlighted .node-name {
  font-weight: bold;
}

.ruleset-tree-wrapper h2 {
  text-align: center;
}

.tree-children .tree-node {
  margin-left: 20px;
}

.rulesetBlock{
  font-weight: bold;
}
</style>

